import { A4 } from 'components/shared/print'
import Appendix1 from 'api/../../public/result_v2/pancreas/appendix1.jpg'
import Appendix2 from 'api/../../public/result_v2/pancreas/appendix2.jpg'
import Appendix3 from 'api/../../public/result_v2/pancreas/appendix3.jpg'
import Appendix4 from 'api/../../public/result_v2/pancreas/appendix4.jpg'
import { Sample } from 'entities/sample'
import { QRCodeSVG } from 'qrcode.react'
import { WITH_TAX_RATE } from 'utils/util'
import moment from 'moment'

type Props = {
    sample: Sample
}
export const ResultPancreasAppendix = ({ sample }: Props) => {
    const isHomeTest = !!process.env.REACT_APP_IS_HOME_TEST
    const env = process.env.REACT_APP_ENV
    if (!isHomeTest) return null
    const upsellingTargetProducts = sample.requestForm?.customerOrder?.purchaseProduct?.upsellingTargetProducts
    const upsellingTargetProduct = upsellingTargetProducts?.find((p) => p.category === 'scan')

    if (!upsellingTargetProduct) return null
    const domain = env === 'production' ? 'misignal.jp' : 'localhost:3004'
    const url = `http://${domain}/mypage/v2/results/scan/${sample.code}/upgrade`
    const baseDate = sample.sendDate ? moment(sample.sendDate) : moment()
    const expiredDate = baseDate.add(14, 'days').format('YYYY年MM月DD日')
    return (
        <>
            <A4 padding={0} landscape={false}>
                <div className="page-root">
                    <img src={Appendix1} style={{ objectFit: 'contain', width: '100%' }} />
                </div>
            </A4>
            <A4 padding={0} landscape={false}>
                <div className="page-root">
                    <img src={Appendix2} style={{ objectFit: 'contain', width: '100%' }} />
                    <div
                        style={{
                            position: 'absolute',
                            top: 194,
                            left: 194,
                            color: '#FF865B',
                            fontFamily: 'Noto Sans JP',
                            fontSize: '48px',
                            fontStyle: 'normal',
                            fontWeight: '700',
                            lineHeight: '63px',
                        }}
                    >
                        {Math.round((upsellingTargetProduct.price ?? 0) * WITH_TAX_RATE)?.toLocaleString()}
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: 191,
                            right: 75,
                            color: '#FBFBA0',
                            textAlign: 'center',
                            fontFamily: 'Noto Sans JP',
                            fontSize: 27,
                            fontStyle: 'normal',
                            fontWeight: '700',
                            lineHeight: '38px',
                            letterSpacing: '-1.4px',
                        }}
                    >
                        {Math.round(((upsellingTargetProduct.price ?? 0) * WITH_TAX_RATE) / 6)?.toLocaleString()}
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            bottom: 361,
                            right: 194,
                            color: '#646464',
                            textAlign: 'center',
                            fontSize: 18,
                            fontStyle: 'normal',
                            fontWeight: '700',
                        }}
                    >
                        {expiredDate}
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            bottom: 93,
                            left: 114,
                        }}
                        onClick={() => {
                            window.open(url, '_blank')
                        }}
                    >
                        <QRCodeSVG value={url} size={70} />
                    </div>
                </div>
            </A4>
            <A4 padding={0} landscape={false}>
                <div className="page-root">
                    <img src={Appendix3} style={{ objectFit: 'contain', width: '100%' }} />
                </div>
            </A4>
            <A4 padding={0} landscape={false}>
                <div className="page-root">
                    <img src={Appendix4} style={{ objectFit: 'contain', width: '100%' }} />
                </div>
            </A4>
        </>
    )
}
